import React, { useEffect } from 'react'
import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { useSelector, useDispatch } from 'react-redux'
import { setTheme } from 'src/store'

export function ThemeProvider({ children, ...props }) {
  const dispatch = useDispatch()
  const themeMode = useSelector((state) => state.theme?.mode || 'system')

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={themeMode}
      enableSystem={true}
      storageKey="voipbin-theme"
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}

export default ThemeProvider
